// extracted by mini-css-extract-plugin
module.exports = {"root":"ResponsiveImage__root--3NMD3","image":"ResponsiveImage__image--1isrA","video":"ResponsiveImage__video--P5NDV","bounce":"ResponsiveImage__bounce--ttviF"};